import { Box, Tooltip, Typography } from "@mui/material";
import { lighten, useTheme } from "@mui/material/styles";
import React from "react";
import { CampaignBrandStatus } from "schemas/dashboard";

interface Props {
  status: CampaignBrandStatus;
}

export const CampaignBrandStatusChip: React.FC<Props> = ({ status }) => {
  const theme = useTheme();

  const statusMap: Record<
    CampaignBrandStatus,
    { label: string; color: string }
  > = {
    [CampaignBrandStatus.pending]: {
      label: "pending",
      color: theme.palette.warning.main,
    },
    [CampaignBrandStatus.no_contact]: {
      label: "no contact found",
      color: theme.palette.error.main,
    },
    [CampaignBrandStatus.scheduled]: {
      label: "",
      color: theme.palette.success.main,
    },
    [CampaignBrandStatus.archived]: {
      label: "archived",
      color: theme.palette.grey[500],
    },
  };

  const { label, color } = statusMap[status];

  return (
    <Box>
      <Typography
        variant="caption"
        component="span"
        sx={{
          color,
          fontWeight: 500,
          fontSize: 10,
          textTransform: "uppercase",
        }}
      >
        {label}
      </Typography>
      <Tooltip title="See your Inbox for more details" enterTouchDelay={0}>
        <Box
          component="span"
          sx={{ ml: 0.5, color: lighten(color, 0.75) }}
          className="fa-solid fa-circle-info fa-2xs"
        />
      </Tooltip>
    </Box>
  );
};
